import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';

import {
  Message,
  Form,
  FormItem,
  Input,
  Dialog,
  Icon,
  Upload,
  // DatePicker,
  MessageBox,
  Image,
  Pagination,
  Carousel,
  CarouselItem,
  Button
} from 'element-ui';
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Upload)
// Vue.use(DatePicker)
Vue.use(Image)
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Button)

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
